<template>
<transition name="fade">
    <div class="detail-container" v-loading="loading">
        <zm-table :data="list.slice((pageable.page - 1) * pageable.size, pageable.page * pageable.size)"
        border class="table-in-detail">
            <zm-table-column label="configName" prop="configName"></zm-table-column>
            <zm-table-column label="configValue" prop="configValue"></zm-table-column>
            <zm-table-column label="modifiedUserName" prop="modifiedUserName"></zm-table-column>
            <zm-table-column label="modifiedTime" prop="modifiedTime" :formatter="setTime"></zm-table-column>
            <zm-table-column label="operation" width="110px" v-if="hasPermission">
                <template slot-scope="scope">
                    <zm-button size="small" class="btn-contain" type="icon" icon="zm-icon-edit" @click="openEdit(scope.row)"></zm-button>
                    <zm-button size="small" class="btn-contain" type="icon" icon="zm-icon-delete" @click="deleteConfig(scope.row.id)"></zm-button>
                </template>
            </zm-table-column>
        </zm-table>
        <div style="text-align: center" class="pagination-wrap">
            <zm-pagination
                :current-page.sync="pageable.page"
                :page-size="pageable.size"
                layout="total, prev, pager, next, jumper"
                :total="pageable.total">
            </zm-pagination>
        </div>
        <zm-dialog :title="form.title" :visible.sync="dialogFormVisible" append-to-body>
            <zm-form :model="form" label-position="left" ref="form" :rules="rules">
                <zm-form-item label="configGroup" :label-width="formLabelWidth" prop="configGroup">
                    <div slot="label">
                        <tip label="configGroup" id="group-detail-configGroup"></tip>
                    </div>
                    <zm-select size="small" v-model="form.configGroup" allow-create filterable disabled>
                        <zm-option v-for="item in groups" :key="item" :value="item" :label="item"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="configName" :label-width="formLabelWidth" prop="configName">
                    <div slot="label">
                        <tip label="configName" id="group-detail-configName"></tip>
                    </div>
                    <zm-select size="small" v-model="form.configName" allow-create filterable>
                        <zm-option v-for="item in names" :key="item" :value="item" :label="item"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item label="configValue" :label-width="formLabelWidth">
                    <div slot="label">
                        <tip label="configValue" id="group-detail-configValue"></tip>
                    </div>
                    <zm-input size="small" v-model.trim="form.configValue"></zm-input>
                </zm-form-item>
            </zm-form>
            <div slot="footer" class="dialog-footer">
                <zm-button size="small" @click="dialogFormVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="save()" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
    </div>
</transition>
</template>
<script>
import { getConfigList, getConfigByGroup, getConfigNames, updateConfig, deleteConfig } from '../../../api/globalconfig'
import tip from 'components/ToolTip/index'
export default {
    props: [
        'group'
    ],
    components: { tip },
    data () {
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            list: [],
            loading: false,
            groups: [],
            names: [],
            pageable: {
                page: 1,
                size: 10,
                total: 0
            },
            formLabelWidth: '100px',
            dialogFormVisible: false,
            form: {
                title: '',
                id: '',
                configGroup: '',
                configName: '',
                configValue: ''
            },
            rules: {
                configGroup: [
                    { required: true, message: 'please enter configGroup', trigger: 'blur' }
                ],
                configName: [
                    { required: true, message: 'please enter configName', trigger: 'blur' }
                ],
                configValue: [
                    { required: true, message: 'please enter configValue', trigger: 'blur' }
                ]
            }
        }
    },
    created () {
        this.fetchData()
    },
    methods: {
        setTime (row, column, cellValue, index) {
            let time = row[column.property]
            return new Date(parseInt(time)).toLocaleString()
        },
        fetchData () {
            this.loading = true
            getConfigByGroup(this.group).then(response => {
                this.list = response
                this.pageable.total = response.length
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        openEdit (row) {
            this.form.title = 'Edit Global Config'
            this.getGroups()
            this.getNames()
            this.form.id = row.id
            this.form.configGroup = row.configGroup
            this.form.configName = row.configName
            this.form.configValue = row.configValue
            this.dialogFormVisible = true
        },
        getGroups () {
            getConfigList().then(response => {
                this.groups = response
            })
        },
        getNames () {
            getConfigNames().then(response => {
                this.names = response
            })
        },
        refreshParent () {
            this.$parent.fetchData()
        },
        save () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    var { id, configGroup, configName, configValue } = this.form
                    const data = { configGroup, configName, configValue }
                    if (this.form.title === 'Edit Global Config') {
                        this.loading = true
                        updateConfig(id, data).then(response => {
                            this.fetchData()
                            this.$message({
                                message: 'Edit config success!',
                                type: 'success'
                            })
                            this.loading = false
                            this.dialogFormVisible = false
                            this.refreshParent()
                            this.$refs.form.resetFields()
                        }).catch(() => {
                            this.loading = false
                        })
                    } else {
                        this.$message({
                            message: 'error!',
                            type: 'error'
                        })
                    }
                } else {
                    this.$message({
                        message: 'Submit error!',
                        type: 'error'
                    })
                    return false
                }
            })
        },
        deleteConfig (id) {
            this.loading = true
            this.$confirm('This will permanently delete the config. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteConfig(id).then(response => {
                    this.loading = false
                    this.fetchData()
                    this.$message({
                        message: 'Delete config success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        }
    }
}
</script>
<style scoped>
.detail-container {
    margin-right: 20px;
}
.table-in-detail {
    margin: 40px 0;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
